import api from '../../utils/api'
import axios from 'axios'

export const state = {}

export const mutations = {  }

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post(`/fispq-logs`, body)
    } catch (e) {
      console.error(e)
    }
  },

  async handleFinish(_, body) {
    try {
      return await api.post(`/fispq-logs/finish`, body)
    } catch (e) {
      console.error(e)
    }
  },
}

export const getters = {

}
